import React, { useEffect, useState } from 'react';
import Nav from '../components/nav.tsx';
import { dummy, dummy2, dummy3, home2n01, home3china, home3hongkong, home3indonesia, home3japan, home3southkorea, home5img, home5logoInsurein } from '../configs/src_routes.ts';
import Footer from '../components/footer.tsx';

const HomePage = () => {

  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  useEffect(() => {
    const imageElement = document.getElementById('image') as HTMLImageElement | null;

    if (imageElement && imageElement.complete) {
      // 이미지가 이미 로드되어 있다면 이미지 로드 상태를 true로 설정
      setImageLoaded(true);
    } else if (imageElement) {
      // 이미지가 로드되지 않았다면 onLoad 이벤트를 추가하여 로드 완료 시 이미지 로드 상태를 true로 설정
      const handleImageLoad = () => {
        setImageLoaded(true);
      };
      imageElement.addEventListener('load', handleImageLoad);

      return () => {
        // 컴포넌트가 언마운트될 때 이벤트 리스너를 정리
        imageElement.removeEventListener('load', handleImageLoad);
      };
    }
  }, []);

  return (
    <div className='body-nav'>
      <div className={'loading-overlay'} style={{animationPlayState: (imageLoaded ? 'running' : 'paused')}}>
        <div className={'balls'}>
          <div />
          <div />
          <div />
        </div>     
      </div>
      <Nav />
      <section id='home1'>
        <div className='home1-scripts'>
          <h1>EMPOWERING YOUR FINANCES WITH HIGH-TECHNOLOGY.</h1>
          <p>We are always by your side, enriching your life with financial solutions that support and grow with you every step of the way.</p>
        </div>
        <div className='home1-img-wrap'>
          <img id='image' className='home1-img1' src={dummy} alt='title video' />
          <img className='home1-img2' src={dummy2} alt='title video2' />
          <img className='home1-img3' src={dummy3} alt='title video2' />
        </div>
      </section>
      <section id='home2'>
        <div className='home2-pad'>
          <div className='home2-scripts'>
            <h2>Providing clear insights into your future with technology— anytime, anywhere.</h2>
            <p>Using advanced technology, we deliver clear and valuable insights into your future, helping you make confident decisions wherever you are, whenever you need them.</p>
          </div>
          <img src={home2n01} alt='idea' />
        </div>
      </section>
      <section id='home3'>
        <div className='home3-pad'>
          <div className='home3-scripts'>
            <h2>Golden Wayve is operating in various countries around the world.</h2>
            <p>Operating in multiple countries, Golden Wayve delivers advanced financial IT solutions that help individuals and businesses navigate the complexities of finance with ease, wherever they are.</p>
          </div>
          <div className='home3-countries'>
            <img src={home3hongkong} alt='hongkong' />
            <img src={home3southkorea} alt='southkorea' />
            <img src={home3japan} alt='japan' />
            <img src={home3china} alt='china' />
            <img src={home3indonesia} alt='indonesia' />
          </div>
        </div>
      </section>
      <section id='home4'>
        <div className='home4-pad'>
          <h2>Improving the financial environment with AI.</h2>
          <div className='home4-img-container'>
            <div className='home4-scripts-1-wrap'>
              <div className='home4-scripts-1'>
                <h3>Profit simulation for different scenarios</h3>
                <p>The AI system derives projected outcomes by considering various factors, such as customer conditions, investment amount, and market situations.</p>
              </div>
            </div>
            <div className='home4-scripts-2-wrap'>
              <div className='home4-scripts-2'>
                <h3>Simplifying financial tasks</h3>
                <p>By minimizing tasks that previously required excessive time and cost due to disorganized and overwhelming information, financial interactions are now streamlined through the most efficient methods.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id='home5'>
        <div className='home5-pad'>
          <div className='home5-top'>
            <img src={home5logoInsurein} alt='insurein logo' />
            <div className='home5-scripts'>
              <h2><span>insurein</span> makes<br/>people's future planning<br/>closer and easier</h2>
              <p>With Insurein, future planning is simple and accessible.<br/>Check your financial information anytime on mobile or PC and discover diverse financial products from across the globe.</p>
            </div>
            <button>Go Website</button>
          </div>
          <img className='home5-img' src={home5img} alt='insurein service' />
        </div>
      </section>
      <section id='home6'>
        <div className='home6-scripts'>
          <h2>Making financial information simple and accessible for everyone.</h2>
          <p>Our vision is to simplify financial information, making it accessible to everyone and empowering them to confidently build a brighter and more secure future.</p>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;